import React, { memo, useRef, useState, useEffect } from "react";

import AutoComplete from "../AutoComplete";
import BingTrendingTermsDropdown from "../BingTrendingTermsDropdown";
import styles from "../style.css";
import {useTranslation} from "react-i18next";
import {getSearchPlaceholder} from "src/utils";
import SideButton from "../SideButton";

const searchBarBtnColorDefaults = {
  none: "#fff",
  bingDirect: "#fa7a21",
  yahooDirect: "#7a2d7a",
  googlecse: "#4285f4",
  "googlecse-inline": "#4285f4"
};

const providerIcons = {
  googlecse: "google_custom_search_left.png",
  "googlecse-inline": "google.png",
  bingDirect: "bing-logo.svg",
  yahooDirect: "yahoo-logo.svg"
};



const MultiProviderSearchBar = memo(props => {
  const {
    autoFocus,
    searchProvider = "",
    searchProviderOverride,
    searchUrl = "/search",
    searchBarPlaceholderText = "Search the web",
    enhancedByGoogleLogoVisibility = true,
    searchBarBtnColor,
    brand = "",
    esn = "",
    zip = "",
    lat = "",
    lng = "",
    autocomplete: autocompleteProp = false,
    bingTrendingTerms = 0,
    bingTrendingStyles = 1,
    bingTrendingTracingID = 0,
    bingTrendingPostBackURL,
    bingTrendingFormCode,
    clientSideEnabledSearchBar = false,
    searchBarBingTrendingTerms,
    bingTrendingSearchType,
    searchBarBingTrendingSearchType,
    searchBarStyle,
    applyBtn
  } = props;
  const provider = searchProviderOverride || searchProvider;

  const searchUrlQueryParams = searchUrl.split("?")[1];
  const searchUrlQueryParamsObj = searchUrlQueryParams ? searchUrlQueryParams.split("&").reduce((acc, curr) => {
    const [key, value] = curr.split("=");
    acc[key] = value;
    return acc;
  }, {}) : {};

  const autocomplete = provider === "bing" && bingTrendingTerms ? false : autocompleteProp;

  const bingTrendingTermsRef = useRef(null);
  const form = useRef();
  const {t: translator} = useTranslation();
  const [value, setValue] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const submitValue = val => {
    setValue(val);
    setTimeout(() => form.current.submit(), 100);
  };

  const closeOnClickOutside = (e) => {
    if (bingTrendingTermsRef.current && !bingTrendingTermsRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  // IF THE PANEL IS OPEN START LISTENING FOR OUTSIDE CLICKS TO CLOSE IT
  useEffect(() => {
    if (dropdownOpen) document.addEventListener("click", closeOnClickOutside, true);

    return () => {
      document.removeEventListener("click", closeOnClickOutside, true);
    };
  }, [dropdownOpen]);

  const placeholder = getSearchPlaceholder(searchBarPlaceholderText, translator);

  const handleSubmit = e => value.trim() === "" && e.preventDefault();
  const formStyle = provider === "googlecse" && enhancedByGoogleLogoVisibility === false ? { marginLeft: "auto" } : undefined;
  return (
    <div class={styles["provider-" + (provider || "none")]}>
      <div
        class={styles.searchBarContainer}
        style={{ backgroundImage: provider === "googlecse" && `url(${window.GLOBALS.ASSETS.GENERIC}/img/search/${providerIcons[provider]})` }}
      >
        <form ref={form} class={[styles.searchForm, applyBtn ? styles.withSideBtn : {}].join(' ')} style={formStyle} action={searchUrl} onSubmit={handleSubmit}>
          <div class={styles.searchBarFieldsContainer}>
            <div>
              <input
                style={{
                  border:
                    (provider === "bingDirect" || provider === "yahooDirect") &&
                    `1px solid ${searchBarBtnColor || searchBarBtnColorDefaults[provider || "none"]}`,
                  backgroundImage:
                    (provider === "bingDirect" || provider === "yahooDirect" || provider === "googlecse-inline") &&
                    `url(${window.GLOBALS.ASSETS.GENERIC}/img/search/${providerIcons[provider]})`
                }}
                class={[styles.searchText, searchBarStyle == '2' ? styles.searchText2 : {}].join(' ')}
                type="text"
                name="search_term"
                placeholder={placeholder}
                autoFocus={autoFocus}
                autoComplete="off"
                value={value}
                onChange={e => setValue(e.target.value)}
                onFocus={() => setDropdownOpen(true)}
              />
              <input type="hidden" name="brand" value={brand} />
              <input type="hidden" name="esn" value={esn} />
              <input type="hidden" name="zip" value={zip} />
              <input type="hidden" name="lat" value={lat} />
              <input type="hidden" name="lng" value={lng} />
              {provider ? <input type="hidden" name="provider" value={provider} /> : null}
              {Object.keys(searchUrlQueryParamsObj).map(key => <input type="hidden" key={key} name={key} value={searchUrlQueryParamsObj[key]} />)}
            </div>
            <button
              alt="Submit"
              class={[styles.searchBarBtn, searchBarStyle == '2' ? styles.searchBarBtn2 : {}].join(' ')}
              style={{ background: searchBarBtnColor || searchBarBtnColorDefaults[provider || "none"] }}
            >
              <img
                class={[styles.searchBtnIcon, searchBarStyle == '2' ? styles.searchBtnIcon2 : {}].join(' ')}
                src={
                  provider === "bingDirect" || provider === "yahooDirect" || provider.startsWith("googlecse")
                    ? "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 18 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M12.867 11.32h-.818l-.283-.282a6.657 6.657 0 0 0 1.613-4.35 6.69 6.69 0 1 0-6.69 6.69c1.662 0 3.179-.61 4.349-1.612l.284.283v.815L16.466 18 18 16.466l-5.133-5.146zm-6.178 0a4.63 4.63 0 1 1 0-9.262 4.631 4.631 0 1 1 0 9.262z'/%3E%3C/svg%3E"
                    : ( searchBarStyle == '2' ? "data:image/svg+xml,%3Csvg width='18' height='17' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath id='Ellipse 739' d='M9.06055 15.4257C13.1036 15.4257 16.3811 12.1482 16.3811 8.10514C16.3811 4.0621 13.1036 0.784576 9.06055 0.784576C5.01752 0.784576 1.73999 4.0621 1.73999 8.10514C1.73999 12.1482 5.01752 15.4257 9.06055 15.4257Z' stroke='%238C8C8C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath id='Line 181' d='M1.13367 1.57724L4.00001 4.43544' transform='translate(13,12)' stroke='%238C8C8C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"
                     : "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 18 18'%3E%3Cpath fill='%234a4a4a' fill-rule='evenodd' d='M12.867 11.32h-.818l-.283-.282a6.657 6.657 0 0 0 1.613-4.35 6.69 6.69 0 1 0-6.69 6.69c1.662 0 3.179-.61 4.349-1.612l.284.283v.815L16.466 18 18 16.466l-5.133-5.146zm-6.178 0a4.63 4.63 0 1 1 0-9.262 4.631 4.631 0 1 1 0 9.262z'/%3E%3C/svg%3E")
                }
              />
            </button>
          </div>
        </form>
      </div>
      {autocomplete ? <AutoComplete query={value} setQuery={submitValue} /> : null}
      {
        dropdownOpen && bingTrendingTerms != "0"
          ? <div ref={bingTrendingTermsRef}>
            <BingTrendingTermsDropdown
              bingTrendingTerms={bingTrendingTerms}
              bingTrendingStyles={bingTrendingStyles}
              bingTrendingTracingID={bingTrendingTracingID}
              bingTrendingPostBackURL={bingTrendingPostBackURL}
              bingTrendingFormCode={bingTrendingFormCode}
              clientSideEnabledSearchBar={clientSideEnabledSearchBar}
              searchBarBingTrendingTerms={searchBarBingTrendingTerms}
              bingTrendingSearchType={bingTrendingSearchType}
              searchBarBingTrendingSearchType={searchBarBingTrendingSearchType} />
          </div>
          : null
      }
       {applyBtn && <SideButton {...props}/>}
    </div>
  );
});

export default MultiProviderSearchBar;
